// eslint-disable-next-line import/prefer-default-export
export { default as reducer } from './reducer';



// WEBPACK FOOTER //
// ./src/cards/reducers/pdp/index.js